module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_17.6fb4913d.jpg";